<template>
	<div class="block-form">
		<h1>Отсканируйте QR авторизации</h1>
		<rc-input v-model="user_name" placeholder="Пользователь" />
		<qrcode-scanner v-show="user_name" :scanFind="findCode" :mode="serverMode" @result="onScan" />
	</div>
</template>
	
<script>
import router from '@/router';
import QrcodeScanner from '@/components/QrcodeScanner'
import store from '@/store'
import axios from 'axios'

export default {
	name: 'ScanLoginView',
	components: {
		QrcodeScanner
	},
	data() {
		return {
			user_name: '',
			serverMode: null,
			codeListLS: [],
			readedCode: '',
			findCode: null,

			// update to scancollector
			lastCode: '',
			orderSendCode: [],
		}
	},
	created() {
		this.user_name = store.state.user.name
	},
	mounted() {
		this.serverMode = this.$store.state.server_mode_select
	},
	watch: {
		readedCode(newCode, oldCode) {
			this.addNewCode(newCode)
		}
	},
	computed: {
		debug() {
			return store.getters.debug
		}
	},
	methods: {
		//update to scancollector
		async onScan(decodedText, decodedResult) {
			store.commit('setUserName', this.user_name)
			axios({
				method: 'post',
				url: 'https://mobile-dev.expo-stat.ru/api/v2/login',
				data: {
					uuid: store.getters.user_id || null,
					login: store.getters.user_name || null,
					point: store.getters.exhib_id || null,
					session: store.getters.event_id || null,
					debug: this.debug,
					data: [{ code: decodedText, readed_ts: Date.now() }]
				}
			}).then((response) => {
				store.commit('update_server_info', {
					status: true,
					status_ts: Date.now()
				})
				switch (response.data.command) {
					case 'is_unlogined':
						// отработать сброс user approve
						store.dispatch('serverUnlogin', null)
						break
					case 'is_logined':
						store.commit('setUserAprove', true)
						router.push({ name: 'exhibSelector' })
						// отработать установку user_id
						break
					default:
						// отработать проверку QR
						break
				}
			})
				.catch(err => {
					store.commit('update_server_info', {
						status: false,
						status_ts: Date.now()
					})
				})
		},
		addNewCode(code) {
			this.codeList[code] = {
				readed_ts: Date.now(),
				sended: false,
				sended_ts: null
			}
		},
	},
}
</script>
	

<style scoped>
.code-list {
	list-style: none;
}

.code-list li {
	padding: .7rem 1rem 1rem;
	border-bottom: 1px solid #a0a0a0;
}
</style>